export type PageMeta = {
  id: string;
  chapter: string;
  /** Auto-advance time in ms. 0 = final page, no auto-advance. */
  duration: number;
  /** Discreet label shown just before the story advances. */
  next: string;
  /** One line for the chapter menu. */
  summary: string;
  theme: "light" | "mist" | "dark" | "brand";
};

export const PAGES: PageMeta[] = [
  { id: "evidence", chapter: "The new evidence", duration: 11000, next: "Continuing to outcomes over time…", summary: "MINT: 62.4% best overall response rate · 109 patients, 18 centers", theme: "dark" },
  { id: "outcomes", chapter: "The outcomes over time", duration: 12000, next: "Continuing to clinical relevance…", summary: "Median PFS 20.2 months · median TTNT 14.9 months", theme: "mist" },
  { id: "patients", chapter: "Why it matters to patients", duration: 11000, next: "Continuing to the patients concerned…", summary: "Skin and blood as disease compartments", theme: "light" },
  { id: "which", chapter: "Which patients?", duration: 11000, next: "Continuing to the trial evidence…", summary: "B0, B1 and B2 blood involvement", theme: "mist" },
  { id: "closer", chapter: "A closer look at the evidence", duration: 11000, next: "Continuing to the treatment…", summary: "MAVORIC compartment responses · German expert guidance", theme: "brand" },
  { id: "treatment", chapter: "The treatment", duration: 11000, next: "Continuing to the clinical consequence…", summary: "EU indication · anti-CCR4 mechanism of action", theme: "light" },
  { id: "consequence", chapter: "The clinical consequence", duration: 10000, next: "Continuing…", summary: "Patient selection, outcomes, treatment management", theme: "dark" },
  { id: "invitation", chapter: "The invitation", duration: 0, next: "", summary: "Full results, references and prescribing information", theme: "brand" },
];
